import { useMemo } from "react";

import createStore from "@Stores/base-factories"
import { hookPostList, hookFormList, hookSiteFieldsList } from "@Stores/base-factories/store-list";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"
import { hookGlobalGetTemplates } from "@Stores/global/factory";

function defineDatasource(templateLoader) {
  const stateLoader = type => {
    let options = null
    return async () => {
      if (!options) {
        options = await templateLoader(type)
        setTimeout(() => {
          options = null
        }, 3000)
      }
      return options
    }
  }
  return {
    loading: stateLoader('feedback-loading'),
    empty: stateLoader('feedback-empty'),
    search_filter: stateLoader('search-filter'),
  }
}

const useFormFactory = ({ fetch, siteSelected: { id: site_id }, collection: { collectionURL }, templates: { getTemplates } }) => useMemo(() => ({
  references: {
    useLoad: async formId => {
      const result = await fetch({
        method: 'get',
        url: `${collectionURL}/${formId}/references`,
        params: { site_id },
      });
      if (!result) {
        throw Error()
      }
      return result
    },
  },
  datasourceTemplates: defineDatasource(getTemplates(
    '/partials/forms/components/custom_fields/datasource',
    [{ value: '', label: 'Default' }],
  )),
}), [collectionURL, fetch, site_id, getTemplates])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('site_id'))
  .extendHookCollectionFactory('form')
  .extendHookCollectionsFactory('forms')
  .extend(hookSiteFieldsList('customFields'))
  .extend(hookGlobalGetTemplates('cms/setting'))
  .extend(hookFormList())
  .extend(hookPostList('landers'))
  .extend(useFormFactory)
  .factory()

export {
  Provider as FormProvider,
  useStore as useFormStore,
}
